import React from 'react';

export default (props) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 4C9.10457 4 10 3.10457 10 2C10 0.89543 9.10457 0 8 0C6.89543 0 6 0.89543 6 2C6 3.10457 6.89543 4 8 4Z" fill="currentColor" />
    <path d="M8 10.0377C9.10457 10.0377 10 9.1423 10 8.03773C10 6.93317 9.10457 6.03773 8 6.03773C6.89543 6.03773 6 6.93317 6 8.03773C6 9.1423 6.89543 10.0377 8 10.0377Z" fill="currentColor" />
    <path d="M8 15.9748C9.10457 15.9748 10 15.0794 10 13.9748C10 12.8703 9.10457 11.9748 8 11.9748C6.89543 11.9748 6 12.8703 6 13.9748C6 15.0794 6.89543 15.9748 8 15.9748Z" fill="currentColor" />
  </svg>
);
